import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = {
  ServerID: -1,
  ServerName: "",
  web_server_url: "",
  Language: "en",
};

export const LoginSettings = createSlice({
  name: "loginSettings",
  initialState: {
    value: initialStateValue,
  },
  reducers: {
    redux_LoginSettings: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
    redux_resetLoginSettings: (state) => {
      state.value = initialStateValue;
    },
  },
});
export const { redux_LoginSettings, redux_resetLoginSettings } =
  LoginSettings.actions;

export default LoginSettings.reducer;
